import type { Company } from "@/modules/companies/client/api/types"
import type { TFunction } from "@/modules/i18n/components/types"

import { COMPANY_PAGE_TYPE } from "@/modules/companies/client/api/endpoints/company"

export type FaqQuestion = {
  id: string
  answer: string
  question: string
}

export const getQuestions = (company: Company, t: TFunction<"companies_client">): FaqQuestion[] => {
  const {
    pageType,
    page: { faq },
  } = company
  const {
    answerHiringProfile,
    answerPermanentContractOpportunity,
    answerRemoteWorkPolicy,
    answerYoungTalentExperience,
    customQuestion1,
    customQuestion2,
  } = faq

  const isPremium = pageType === COMPANY_PAGE_TYPE.PREMIUM
  const isWithCustomQuestion1 = isPremium && !!customQuestion1 && !!customQuestion1.question && !!customQuestion1.answer
  const isWithCustomQuestion2 = isPremium && !!customQuestion2 && !!customQuestion2.question && !!customQuestion2.answer

  const questions: FaqQuestion[] = [
    {
      answer: answerYoungTalentExperience,
      id: "youngTalentExperience",
      question: t("companies_client.information.faq.question.young_talent_experience"),
    },
    {
      answer: answerPermanentContractOpportunity,
      id: "permanentContractOpportunity",
      question: t("companies_client.information.faq.question.full_time_opportunity"),
    },
    {
      answer: answerHiringProfile,
      id: "hiringProfile",
      question: t("companies_client.information.faq.question.hiring_profile"),
    },
    {
      answer: answerRemoteWorkPolicy,
      id: "remoteWorkPolicy",
      question: t("companies_client.information.faq.question.remote_work_policy"),
    },
  ]

  if (isWithCustomQuestion1) {
    questions.push({
      answer: customQuestion1.answer,
      id: "customQuestion1",
      question: customQuestion1.question,
    })
  }

  if (isWithCustomQuestion2) {
    questions.push({
      answer: customQuestion2.answer,
      id: "customQuestion2",
      question: customQuestion2.question,
    })
  }

  return questions
}
